<div [class]="class === '' ? 'flex flex-column gap-3': class">
  <div *ngFor="let option of options" class="field-checkbox">
      <p-radioButton  [inputId]="option.key"  [value]="option.key" [formControl]="value"></p-radioButton>
      <label [for]="option.key" class="ml-2">{{ option.name }}</label>
  </div>
</div>

